// extracted by mini-css-extract-plugin
export default {"root":"EditButton_root__hzSW-","icon":"EditButton_icon__7SEOO","isCenterAligned":"EditButton_isCenterAligned__3HaZe"};